import { googleOAuthProvider } from './providers/googleOAuthProvider.js';
import { localAuthProvider } from './providers/localAuthProvider.js';

export const loginProviders = [googleOAuthProvider, localAuthProvider];
